module.exports = __webpack_public_path__ + "static/img/3.44cb002.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/3.png
// module id = 9O6Z
// module chunks = 0